import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Flex, Text, Grid } from '@chakra-ui/react';
import React from 'react';
import { Button } from '../../../components/button/button';
import { ModalComponent } from '../../../components/Modal/modal';
import { ButtonVariant } from '../../../core/enums';
import { styles } from '../dictionary-styles';
import './request-errors.scss';
/**
 * React component that displays Dictionary Request Errors
 * @param props
 * @returns
 */ const RequestErrors = (props)=>{
    const { errors = [], openModal, handleClose } = props;
    const classes = styles();
    const requestErrors = Array.isArray(errors) ? errors : [];
    const errorMessages = requestErrors.map((error, idx)=>{
        return /*#__PURE__*/ _jsxs("li", {
            children: [
                error.errorMessage,
                ": '",
                error.valueInError,
                "' from ",
                error.columnInError,
                ' ',
                "in:",
                /*#__PURE__*/ _jsxs("ul", {
                    style: {
                        marginLeft: '10px'
                    },
                    children: [
                        /*#__PURE__*/ _jsxs("li", {
                            children: [
                                "Organization: ",
                                error.mappedDictionaryOrganizationName,
                                " "
                            ]
                        }),
                        error.mappedParentDictionaryOrganizationName && /*#__PURE__*/ _jsx("li", {
                            children: "Inherited From Codametrix"
                        }),
                        /*#__PURE__*/ _jsxs("li", {
                            children: [
                                "Dictionary: ",
                                error.mappedDictionaryName
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("li", {
                            children: [
                                "Column: ",
                                error.mappedDictionaryLookupColumn
                            ]
                        })
                    ]
                })
            ]
        }, idx);
    });
    const stringifiedErrors = requestErrors.map((error)=>{
        return `${error.errorMessage}: '${error.valueInError}' from ${error.columnInError} in:
            Organization: ${error.mappedDictionaryOrganizationName}
            ${error.mappedParentDictionaryOrganizationName && 'Inherited From Codametrix'}
            Dictionary: ${error.mappedDictionaryName}
            Column: ${error.mappedDictionaryLookupColumn}
            `;
    });
    const _handleCopyError = ()=>{
        navigator.clipboard.writeText(stringifiedErrors.join(''));
    };
    return /*#__PURE__*/ _jsx("div", {
        children: /*#__PURE__*/ _jsx(ModalComponent, {
            size: 'xl',
            showCloseIcon: true,
            isOpen: openModal,
            handleClose: handleClose,
            modalHeader: /*#__PURE__*/ _jsx(Text, {
                children: "Dictionary Request Error"
            }),
            modalContent: /*#__PURE__*/ _jsxs(Grid, {
                sx: classes.errorGrid,
                children: [
                    /*#__PURE__*/ _jsx(Text, {
                        sx: classes.errorText,
                        children: "Error!"
                    }),
                    /*#__PURE__*/ _jsx(Flex, {
                        flexDirection: 'column',
                        id: "error-list",
                        sx: classes.errorList,
                        children: errorMessages
                    })
                ]
            }),
            modalFooter: /*#__PURE__*/ _jsx(Flex, {
                flexDirection: 'row',
                columnGap: 3,
                children: /*#__PURE__*/ _jsx(Flex, {
                    children: /*#__PURE__*/ _jsx(Button, {
                        label: 'Copy Error',
                        onClick: _handleCopyError,
                        variant: ButtonVariant.PRIMARY
                    })
                })
            })
        })
    });
};
export default RequestErrors;
